import {useEffect, useState} from "react";

import VLFModal from "@/components/Modal";
import VLFSelectNew from "@/components/Input/SelectNew";

import {REQUIRED_FIELD} from "@/utils/constants";
import {checkRequiredFields, getTextField} from "@/utils/functions";

const sanctionsTypes = [
	{value: "yellow_card", label: "Cartellino giallo"},
	{value: "double_yellow_card", label: "Doppio cartellino giallo"},
	{value: "red_card", label: "Cartellino rosso"},
];

function HandleEventModal(props) {
	const {open, confirm, close, initialData} = props;

	const [formData, setFormData] = useState({});
	const [errors, setErrors] = useState([]);

	useEffect(() => {
		if (!open) {
			setFormData({});
		}
	}, [open]);

	const getRequiredFields = () => {
		switch (initialData?.type) {
			case "goal":
				return ["player", "minute", "fraction"];
			case "sanction":
				return ["player", "eventType", "minute", "fraction"];
			case "substitution":
				return ["player", "substitutePlayer", "minute", "fraction"];
			default:
				return [];
		}
	};

	const defaultTextField = {
		values: formData,
		setValues: setFormData,
		errors,
		setErrors,
	};

	return (
		<VLFModal
			open={open}
			title={"Aggiungi informazione"}
			close={close}
			confirm={() => {
				const errors = checkRequiredFields(getRequiredFields(), formData);
				setErrors(errors);

				if (!errors.length) {
					confirm({
						...formData,
					});
				}
			}}
			content={
				<div className="row">
					<div className="col-12">
						<VLFSelectNew
							options={initialData?.players
								?.filter((p) =>
									initialData?.type === "substitution" ? !p.startingPlayer : p,
								)
								?.map((p) => {
									return {
										value: p.player.id,
										label:
											p.playerNumber +
											" - " +
											p.player.firstName +
											" " +
											p.player.lastName,
										playerNumber: p.playerNumber,
										sortKey: p.player.lastName,
									};
								})}
							sortKey="sortKey"
							value={formData?.player || ""}
							onChange={(value) => {
								setErrors([]);
								setFormData({
									...formData,
									player: value,
								});
							}}
							required
							helperText={errors.indexOf("player") !== -1 ? REQUIRED_FIELD : ""}
							error={errors.indexOf("player") !== -1}
							label={
								initialData?.type === "substitution" ? "Entra" : "Giocatore"
							}
						/>
					</div>
					{initialData?.type === "substitution" && (
						<div className="col-12">
							<VLFSelectNew
								options={initialData?.players
									?.filter((p) =>
										initialData?.type === "substitution" ? p.startingPlayer : p,
									)
									?.map((p) => {
										return {
											value: p.player.id,
											label:
												p.playerNumber +
												" - " +
												p.player.firstName +
												" " +
												p.player.lastName,
											playerNumber: p.playerNumber,
											sortKey: p.player.lastName,
										};
									})}
								sortKey="sortKey"
								value={formData?.substitutePlayer || ""}
								onChange={(value) => {
									setErrors([]);
									setFormData({
										...formData,
										substitutePlayer: value,
									});
								}}
								required
								helperText={
									errors.indexOf("substitutePlayer") !== -1
										? REQUIRED_FIELD
										: ""
								}
								error={errors.indexOf("substitutePlayer") !== -1}
								label="Esce"
							/>
						</div>
					)}
					{initialData?.type === "sanction" && (
						<div className="col-12">
							<VLFSelectNew
								options={sanctionsTypes}
								sorted={false}
								value={formData?.eventType || ""}
								onChange={(value) => {
									setErrors([]);
									setFormData({
										...formData,
										eventType: value,
									});
								}}
								required
								helperText={
									errors.indexOf("eventType") !== -1 ? REQUIRED_FIELD : ""
								}
								error={errors.indexOf("eventType") !== -1}
								label="Tipologia"
							/>
						</div>
					)}
					<div className="col-6">
						{getTextField({
							...defaultTextField,
							type: "number",
							fieldKey: "minute",
							label: "Minuto",
							required: true,
						})}
					</div>
					<div className="col-6">
						{getTextField({
							...defaultTextField,
							type: "number",
							fieldKey: "fraction",
							label: "Tempo",
							required: true,
						})}
					</div>
				</div>
			}
		/>
	);
}

export default HandleEventModal;
